import React from 'react';
import { useCenturionHomepageContent } from '@/hooks/cdaasHooks/cdaasHelperHooks';
import { CenturionNetworkHero } from './CenturionNetworkHero';
import { CenturionIntroSection } from './CenturionIntroSection';
import { CenturionCarrouselSection } from './CenturionCarrouselSection';
import { CenturionNetworkLounges } from './CenturionNetworkLounges';
import { CenturionNetworkFAQs } from './CenturionNetworkFAQs';
import { CenturionHomepage } from '../CulinaryCollective/interface';

const CenturionNetworkPage = () => {
  const centurionHomepageContent: CenturionHomepage =
    useCenturionHomepageContent();

  const {
    title,
    pageIntro,
    threeUpBlocks: networkHighlights,
    hero,
  } = centurionHomepageContent;

  return (
    <div className="tw-flex tw-flex-col">
      <CenturionNetworkHero content={hero} />
      <div className="tw-mx-auto tw-flex tw-flex-col tw-p-3 tw-px-4 md_tw-px-6 lg_tw-max-w-360 lg_tw-px-8 xl_tw-px-10">
        <CenturionIntroSection
          title={title}
          intro={pageIntro}
          networkHighlights={networkHighlights}
        />
      </div>
      <div>
        <CenturionCarrouselSection />
      </div>
      <div className="tw-mx-auto tw-flex tw-flex-col tw-px-4 sm_tw-pt-20 md_tw-px-6 lg_tw-max-w-360 lg_tw-px-8 xl_tw-px-10">
        <CenturionNetworkLounges />
      </div>
      <div className="tw-mx-auto tw-w-full tw-px-4 md_tw-px-6 lg_tw-max-w-360 lg_tw-px-8 xl_tw-px-10">
        <CenturionNetworkFAQs />
      </div>
    </div>
  );
};

export default CenturionNetworkPage;
